export const SUCCESS_TOAST = "toast/SUCCESS_TOAST";
export const ERROR_TOAST = "toast/ERROR_TOAST";
export const CLEAR_TOAST = "toast/CLEAR_TOAST";

export const SuccessToast = (summary, detail)=>{
    return {type: SUCCESS_TOAST, summary, detail}
}
export const ErrorToast = (summary, detail)=>{
    return {type: ERROR_TOAST, summary, detail}
}
export const ClearToast = ()=>{    
    return {type: CLEAR_TOAST}
}